<template>
<li class="lista-rezultata-single" :class="{'active': value.name == ownName}" @click.prevent="showUserDetails()">
    <span class="tag">{{ isUserLiga ? userPositionPaded : position }}</span>
    <p class="cf">
        <span>
            {{ value.name }}
        </span>
        <span>
            {{ value.points }}
            <small>Bodova</small>
        </span>
    </p>
</li>
</template>

<script>

export default {
    name: 'lista-rezultata-single',
    props: [
        'value',
        'isUserLiga',
        'userPosition',
        'ligaSelected',
        'quizSelected'],
    computed: {
        position () {
            try {
                return this.value.position.toString().padStart(4, '0')
            } catch (error) {
                console.error(error)
            }
            return '0000'
        },
        userPositionPaded () {
            try {
                return this.userPosition.toString().padStart(4, '0')
            } catch (error) {
                console.error(error)
            }
            return '0000'
        },
        ownName () {
            try {
                return this.$store.state.metadata.userData.name
            } catch (error) {
                console.error(error)
            }
            return ''
        },
        isGroupsSelected () {
            try {
                return this.ligaSelected === 'groups'
            } catch (error) {
                return false
            }
        }
    },
    methods: {
        showUserDetails () {
            if (!this.isGroupsSelected) {
                if (this.value.uid && this.quizSelected) {
                    this.$router.push(`/rezultati/korisnik/${this.value.uid}/${this.quizSelected}`)
                }
                if (this.value.uid && !this.quizSelected) {
                    this.$router.push(`/korisnik/${this.value.uid}`)
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.lista-rezultata-single {
    & {
        position: relative;
        display: block;
        border-bottom: 1px solid #d6d6d6;
        padding: 0 0 8px 30px;
        margin-bottom: 12px;
        cursor: pointer;
    }
    &:hover {
        p {
            color: #10549b;
        }
        .tag {
            transform: translate3d(-3px, 0, 0);
        }
    }

    &.active .tag {
        box-shadow: 0px 9px 10px 0px rgba(255, 0, 92, 0.25);
        background: linear-gradient(135deg, rgba(255, 0, 132, 1) 0%, rgba(255, 0, 29, 1) 100%);
    }

    .tag {
        position: absolute;
        top: -2px;
        left: -28px;
        display: block;
        border-radius: 6px;
        min-width: 50px;
        font-size: 10px;
        text-align: center;
        color: #fff;
        font-weight: 800;
        letter-spacing: 1px;
        padding: 5px 3px;
        background-color: #08305d;
    }

    p {
        font-family: "axiforma";
        color: #000;
        margin: 0;

        span:first-child {
            text-align: left;
            float: left;
            font-size: 16px;
            line-height: 16px;
            letter-spacing: .3px;
        }

        span:last-child {
            text-align: right;
            float: right;
            font-family: "mPlus";
            font-size: 18px;
            line-height: 16px;
            letter-spacing: -.2px;

            small {
                text-transform: uppercase;
            }
        }

        small {
            display: block;
            font-weight: 600;
            color: #adadae;
            letter-spacing: .5px;
            font-size: 11px;
            line-height: 22px;
        }
    }
}
</style>
